import { Injectable } from '@angular/core';
import {
  FilterDTO,
  PagedResultDTOOfParkerRegistrationReportDTO,
  ParkerRegistrationReportClient,
  ParkerRegistrationsReportParameterDTO,
  SavedReportFileDTO,
  SortDirection,
} from '../../../../base/models/models.swagger.generated';
import { Observable, of, throwError } from 'rxjs';
import { ToastService } from '../../../../base/services/toast.service';
import { catchError, map } from 'rxjs/operators';
import { ErrorType } from '../../../../core/routing/error-types';
import { ClientService } from '../../../../base/services/client/client.service';
import { SaveOptions } from '../../reports-footer/save-options';
import { ShowInactiveService } from '../../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

export const controlPlateField = 'ControlPlate';
export const countryCodeField = "CountryCode";

@Injectable()
export class ParkerRegistrationReportService extends ShowInactiveService implements IAdaptorService {
  public parameters: ParkerRegistrationsReportParameterDTO = new ParkerRegistrationsReportParameterDTO();

  constructor(private parkerRegistrationReportClient: ParkerRegistrationReportClient,
              private clientService: ClientService,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfParkerRegistrationReportDTO> {
    if (!this.parameters.dateRange.startDate || !this.parameters.dateRange.endDate) {
      return of(new PagedResultDTOOfParkerRegistrationReportDTO());
    }
    if (!filters) {
      filters = [];
    }
    if (!sortBy) {
      sortBy = 'Id';
    }
    if (!sortDirection) {
      sortDirection = SortDirection.Descending;
    }
    return this.parkerRegistrationReportClient.searchParkerRegistrationsReportData(this.clientService.selectedClient.id, this.parameters, skip, take, sortBy, sortDirection)
      .pipe(
        map(result => {
          result?.items?.forEach(item => {
            (item as any)[controlPlateField] = item.knownTag
              ? item.knownTag.controlPlateNumber
              : item.unknownParkerTagOperationalControlPlateNumber;
            (item as any)[countryCodeField] = item.knownTag
              ? item.knownTag.countryCode
              : item.unknownParkerTagCountryCode;
          });
          return result;
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(parkerRegistrationsReportParameterDTO: ParkerRegistrationsReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.parkerRegistrationReportClient.exportParkerRegistrationsReport(
      this.clientService.selectedClient.id,
      saveOptions.exportType,
      saveOptions.saveReport,
      parkerRegistrationsReportParameterDTO,
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
